import { Swiper, SwiperSlide } from 'swiper/react'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { TemplateCategoriesType } from 'builder/hooks/useGetTemplateCategories'
import * as Styled from './styles'

type Props = {
  isLoading: boolean
  selectedCategory: string
  categories?: TemplateCategoriesType
  onSelectCategory: (category: string) => void
}

export const TemplateCategories = ({
  isLoading,
  categories,
  selectedCategory,
  onSelectCategory,
}: Props) => {
  const { isAboveTablet } = useMediaQueries()
  const categoriesKeys = Object.keys(categories || {})

  if (isLoading) {
    return (
      <Styled.TemplateCategories>
        <Styled.LoaderContainer>
          <Styled.Loader />
        </Styled.LoaderContainer>
      </Styled.TemplateCategories>
    )
  }

  if (!isAboveTablet) {
    return (
      <Styled.TemplateCategories>
        <Swiper slidesPerView="auto" spaceBetween={8}>
          {categoriesKeys.map(category => (
            <SwiperSlide key={category}>
              <Styled.TemplateCategory
                isActive={category === selectedCategory}
                onClick={() => onSelectCategory(category)}
              >
                {categories?.[category as keyof TemplateCategoriesType]?.display_name}
              </Styled.TemplateCategory>
            </SwiperSlide>
          ))}
        </Swiper>
      </Styled.TemplateCategories>
    )
  }

  return (
    <Styled.TemplateCategories>
      {categoriesKeys.map(category => (
        <Styled.TemplateCategory
          key={category}
          isActive={category === selectedCategory}
          onClick={() => onSelectCategory(category)}
        >
          {categories?.[category as keyof TemplateCategoriesType]?.display_name}
        </Styled.TemplateCategory>
      ))}
    </Styled.TemplateCategories>
  )
}
